import { COMPONENT_TYPES } from '../../../constants';
import PayLetterFail from './PayLetterFail';
import PayLetterFailEditor from './PayLetterFail.editor';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.PAYLETTER_FAIL,
  component: PayLetterFail,
  editorComponent: PayLetterFailEditor,
  defaultProps: {
    style: {
      width: '100%',
      padding: '40px 0',
      backgroundColor: 'transparent'
    },
    componentProps: {
      className: 'payletter-fail-container',
      title: '결제에 실패했습니다',
      failMessage: '결제가 취소되었거나 실패했습니다.',
      retryButtonText: '다시 결제하기',
      cartButtonText: '장바구니로 이동',
      homeButtonText: '홈으로 돌아가기'
    }
  },
  category: 'payment',
  icon: '❌',
  name: 'PayLetter 결제 실패'
});

export { default as PayLetterFailComponent } from './PayLetterFail';
export { default as PayLetterFailEditor } from './PayLetterFail.editor';
export * from './PayLetterFail.types'; 